import SensoryProfile from './SensoryProfile';
import { formatAlcohol } from '../../utils/wineHelpers';

const WineTechnicalSection = ({ technical }) => {
  const hasSensory = technical.intensity || technical.tannin;

  return (
    <div className="bg-gradient-to-br from-[#2a2535] to-[#1a1625] rounded-2xl p-6 border border-gray-700/50">
      <SensoryProfile technical={technical} />

      <div className={hasSensory ? 'border-t border-gray-700/50 pt-6 mt-2' : ''}>
        <h3 className="text-wine-gold text-sm font-semibold uppercase tracking-wide mb-4">
          🔬 Detalhes Técnicos
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-wine-dark/50 rounded-xl p-4 text-center">
            <p className="text-gray-400 text-xs uppercase tracking-wide mb-2">Teor Alcoólico</p>
            <p className="text-white text-xl font-semibold">{formatAlcohol(technical.alcohol)}</p>
          </div>
          <div className="bg-wine-dark/50 rounded-xl p-4 text-center">
            <p className="text-gray-400 text-xs uppercase tracking-wide mb-2">Temperatura</p>
            <p className="text-white text-xl font-semibold">{technical.temperature || '—'}</p>
          </div>
          <div className="bg-wine-dark/50 rounded-xl p-4 text-center">
            <p className="text-gray-400 text-xs uppercase tracking-wide mb-2">Envelhecimento</p>
            <p className="text-white text-base font-semibold">{technical.aging || '—'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WineTechnicalSection;
